<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/school-history/${inputs.id}`
						: `transaction/school-history`
				"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_school_name" class="col-sm-3 mb-0">
						School Name
					</label>
					<app-input
						id="inputs_school_name"
						type="advance-search-select"
						class="col-sm-9"
						:loaded-per-time="10"
						v-model="input_school_name"
						@input="setSchoolName"
						fetch-url="master/school"
						placeholder="School Name"
						list-value-field="name"
						required
					/>
				</div>
				<div class="form-group row align-items-center" v-if="isSchoolNameOther">
					<label for="inputs_school_level" class="col-sm-3 mb-0">
						Other <br>School Name
					</label>
					<app-input
						type="text"
						class="col-sm-9"
						v-model="inputs.school_name_other"
						placeholder="Please Type Your Child's School Name"
						name="school_name_other"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_school_level" class="col-sm-3 mb-0">
						School Level
					</label>
					<app-input
						id="inputs_school_level"
						class="col-sm-9"
                    	type="multi-select"
						:loaded-per-time="10"
						v-model="input_school_level"
						@input="setSchoolLevel"
						:list="schoolLevelLists"   
						placeholder="School Level"
						list-value-field="name"
                    	:isAnimatedDropdown="true"
						required
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_is_chinese_lesson" class="col-sm-3 mb-0">
						Have Chinese Lesson at School
					</label>
					<app-input
						id="inputs_is_chinese_lesson"
						class="col-sm-9"
						type="radio"
						v-model="inputs.is_chinese_lesson"
						:list="isChineseLessonLists"
						placeholder="Chinese Lesson at School"
					/>
				</div>

				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../Mixins/ModalMixin";

export default {
	name: "SchoolHistoryTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {
				clc_id_number: this.value?.clc_id_number ?? "",
				is_chinese_lesson: 0,
			},
			modalId: this.formId,
			modalTitle: this.$t("add"),
			schoolNameLists: [],
			isSchoolNameOther: false,
			isChineseLessonLists: [
				{ id: 0, value: "No" },
				{ id: 1, value: "Yes" },
			],
			input_school_name: this.value
				? this.value.school
					? {
							id: this.value.school.id || 0,
							name: this.value.school.name || "",
							code: this.value.school.code,
							is_active: this.value.school.is_active,
					  }
					: {
							id: this.value.school?.id || 0,
							name: this.value.school?.name || "",
							code: this.value.school?.code,
							is_active: this.value.school?.is_active,
					  }
				: {
						id: this.value.school.id || 0,
						name: this.value.school.name || "",
						code: this.value.school.code,
						is_active: this.value.school.is_active,
				  },
			
			schoolLevelLists: [],
			input_school_level: [],
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}

		this.fetchData();
	},
	mounted() {
		if (this.modalTitle === this.$t("add")) {
			this.input_school_name = {
				id: 0,
				name: "",
				code: "",
				is_active: 1,
			};
			this.input_school_level = {
				id: 0,
				name: "",
				code: "",
				is_active: 1,
			};
		}
	},
	methods: {
		async fetchData() {
			try {
				let [schoolNameResponse, schoolLevelResponse] =
					await Promise.all([
						axios.get("/master/school?per_page=50"),
						axios.get("/master/school-level?per_page=50"),
					]);

				schoolNameResponse.data.data.forEach((item) => {
					this.schoolNameLists.push({
						id: item.id,
						value: item.name,
					});
				});

				schoolLevelResponse.data.data.forEach((item) => {
					this.schoolLevelLists.push({
						id: item.id,
						name: item.name,
					});
				});
				if (this.inputs.levels) {
					this.setSelectedSchoolLevel();
				}
			} catch (error) {
				console.error("Error fetching data:", error);
			} finally {
				this.preloader = false;
			}
		},
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.input_school_name = {
				id: this.inputs.school_list.id || 0,
				name: this.inputs.school_list.name || "",
				code: this.inputs.school_list.code,
				is_active: this.inputs.school_list.is_active,
			};
			this.isSchoolNameOther= this.input_school_name?.name === 'Others';
			
		},
		setSchoolName(data) {
			this.isSchoolNameOther = false;
			this.inputs.school_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				if(data.name == 'Others'){
					this.isSchoolNameOther = true;
				}
				this.inputs.school_id = data.id;
			}
		},
		setSchoolLevel(data) {
  			this.inputs.school_level_id = data;
		},
		setSelectedSchoolLevel() {
			
			this.input_school_level = this.inputs.levels.map(level => {
				return level.school_level_id;
			});

    		this.inputs.school_level_id = this.input_school_level;

		},
	},
};
</script>
